import React from 'react'

import VersionHistoryCopyAppBar from '../../../../common/VersionHistoryCopyAppBar'
import SelectRevisionTable from '../../../NodeActions/assets/components/SelectRevision/SelectRevisionTable'

const SelectRevisionScreen = ({
    handleCancel,
    data_for_copy_and_replace,
    onSelect,
}) => {
    console.log("data_for_copy_and_replace", data_for_copy_and_replace)
    const {procedure_rev_ref,partNumber,revision, item_code_type} = data_for_copy_and_replace?.completeData?.version_content || {};

  
  return <>
    {/* AppBar with blue title and cancel button */}
    <VersionHistoryCopyAppBar
      title={`Copy & Replacing ${item_code_type} ${partNumber}, Rev ${revision}. Select the Document`}
      showColorTitle={true}  // This makes the title blue
      showBlackTitle={false}
      showCancelButton={true}
      onCancel={handleCancel}
      showBackButton={false}
      showProfileButton={false}
      showTablesDropdown={false}
      buttons={[]}
    />
    
    <SelectRevisionTable
      sourcePartNumber={partNumber}
      fromRevision={revision}
      procedureRevisionId={procedure_rev_ref}
      onRevisionSelect={onSelect}
      isPendingTaskCheckRequired={true}
    />
    
  </>
}

export default SelectRevisionScreen